module.exports = __webpack_public_path__ + "static/media/exportCsv.ac2475f8.svg";